import { useNavigate } from 'react-router-dom';
import { EventManagerNavigation } from '@components/event-manager-navigation';

import { Props } from '../layout.type';

export const LayoutEvents = ({ children }: Props) => {
  const navigate = useNavigate();
  return <EventManagerNavigation navigateTo={navigate}>{children}</EventManagerNavigation>;
};
